import { render } from "./BlockedStatus.vue?vue&type=template&id=15320f24&scoped=true&ts=true"
import script from "./BlockedStatus.vue?vue&type=script&lang=ts"
export * from "./BlockedStatus.vue?vue&type=script&lang=ts"

import "./BlockedStatus.vue?vue&type=style&index=0&id=15320f24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15320f24"],['__file',"src/components/kyc/BlockedStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15320f24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15320f24', __exports__)) {
    api.reload('15320f24', __exports__)
  }
  
  module.hot.accept("./BlockedStatus.vue?vue&type=template&id=15320f24&scoped=true&ts=true", () => {
    api.rerender('15320f24', render)
  })

}


export default __exports__